module.exports = __webpack_public_path__ + "img/trending-down.e668a7d1.svg";